import { useLayoutEffect, useState } from "react";

export function announcementPlacement(rect, viewportWidth, viewportHeight) {
  const margin = 16;
  const gap = 10;
  const below = Math.max(0, viewportHeight - rect.bottom - gap - margin);
  const above = Math.max(0, rect.top - gap - margin);
  const upward = below < Math.min(420, above);
  const width = Math.min(430, viewportWidth - margin * 2);
  const onLeft = rect.left + rect.width / 2 < viewportWidth / 2;
  const left = Math.max(margin, Math.min(onLeft ? rect.left : rect.right - width, viewportWidth - width - margin));
  return {
    left, right: "auto", width,
    top: upward ? "auto" : rect.bottom + gap,
    bottom: upward ? viewportHeight - rect.top + gap : "auto",
    maxHeight: Math.min(620, upward ? above : below),
    transformOrigin: `${upward ? "bottom" : "top"} ${onLeft ? "left" : "right"}`,
  };
}

export default function useAnnouncementPopover(anchorRef, open, positionKey) {
  const [style, setStyle] = useState(null);
  useLayoutEffect(() => {
    if (!open || !anchorRef.current) return;
    const update = () => setStyle(announcementPlacement(anchorRef.current.getBoundingClientRect(), window.innerWidth, window.innerHeight));
    update();
    const observer = new ResizeObserver(update);
    observer.observe(anchorRef.current);
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => { observer.disconnect(); window.removeEventListener("resize", update); window.removeEventListener("scroll", update, true); };
  }, [anchorRef, open, positionKey]);
  return style || { visibility: "hidden" };
}
